<template>
    <div>
        <VueSlickCarousel v-bind="settings">
            <slot></slot>
        </VueSlickCarousel>
    </div>
</template>

<script>
import VueSlickCarousel from 'vue-slick-carousel'
import 'vue-slick-carousel/dist/vue-slick-carousel.css'
// optional style for arrows & dots
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'

export default {
    //name: 'KBSlickCarousel',
    components: { VueSlickCarousel },
    props : {
        autoplay: {
            type: Boolean,
            default: false
        },
        speed: {
            type: Number,
            default: 2000
        },
        edition_slug: ''
    },
    data() {
        return {
            settings: {
                "centerMode":true,
                "centerPadding":"20px",
                "infinite": true,
                "slidesToShow": 6,
                "slidesToScroll": 1,
                "autoplay": true,
                "speed": 2000,
                "autoplaySpeed": 2000,
                "cssEase": "linear",
                "pauseOnDotsHover": true,
                "pauseOnFocus": true,
                "pauseOnHover": true,
                "arrows": false,
                "dots": false,
                "responsive": [
                    {
                        "breakpoint": 1024,
                        "settings": {
                            "slidesToShow": 4,
                            "slidesToScroll": 1,
                        }
                    },
                    {
                        "breakpoint": 600,
                        "settings": {
                            "slidesToShow": 3,
                            "slidesToScroll": 1,
                        }
                    },
                    {
                        "breakpoint": 480,
                        "settings": {
                            "slidesToShow": 2.5,
                            "slidesToScroll": 1
                        }
                    },
                    {
                        "breakpoint": 320,
                        "settings": {
                            "slidesToShow": 2,
                            "slidesToScroll": 1
                        }
                    }
                ]
            },

        }
    },
    created() {
        this.settings.autoplay = this.autoplay;
        this.settings.speed = this.speed;
    },
}
</script>
